import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import axios from "axios";

import { Alert } from "reactstrap";
import { AvForm, AvField } from "availity-reactstrap-validation";
import Checkbox from "@material-ui/core/Checkbox";

const CreateEditRole = (props) => {
  const { t } = useTranslation();
  let link = localStorage.getItem("link");
  let data = props.data;
  let dataUI = props.dataUI;

  const [roleName, setRoleName] = useState();
  const [roleId, setRoleId] = useState();
  const [rightsForRole, setRightsForRole] = useState([]);
  const [heading, setHeading] = useState("");
  const [failShow, setFailShow] = useState(false);
  const [errorMessage, setErrorMessage] = useState();

  useEffect(() => {
    axios.defaults.headers.common["Authorization"] =
      "Bearer " + localStorage.getItem("JWT");
  }, [localStorage.getItem("JWT")]);

  useEffect(() => {
    let roleName = "";
    let roleId = -1;
    let rightIds = [];
    let heading = t("administration.rolesAndRights.newRole");

    if (data != null) {
      heading = t("administration.rolesAndRights.editRole");
      data.roleName != null ? (roleName = data.roleName) : (roleName = "");
      data.roleID != null ? (roleId = data.roleID) : (roleId = -1);
      data.rightIds != null ? (rightIds = data.rightIds) : (rightIds = []);
    }
    setHeading(heading);
    setRoleName(roleName);
    setRoleId(roleId);
    setRightsForRole(rightIds);
  }, [props]);

  let selectedType = props.type;

  function roleNameChange(props) {
    setRoleName(props);
    setFailShow(false);
  }
  const onRightsForRoleChange = (e) => {
    if (e.target.checked === true) {
      setRightsForRole([...rightsForRole, parseInt(e.target.value)]);
    } else if (e.target.checked === false) {
      let freshArray = rightsForRole.filter(
        (val) => val !== parseInt(e.target.value)
      );
      setRightsForRole([...freshArray]);
    }
  };

  function rightsList() {
    let groupList = [];

    for (let i = 0; i < dataUI.length; i++) {
      let subGroupsList = [];

      if (dataUI[i].subGroups) {
        for (let k = 0; k < dataUI[i].subGroups.length; k++) {
          let rightsList1 = [];
          const subGroup = dataUI[i].subGroups[k];
          for (let j = 0; j < subGroup.rights.length; j++) {
            const right = subGroup.rights[j];
            rightsList1.push(
              <div className="flex-iac" style={{ width: "33%", float: "left" }}>
                <Checkbox
                  color="primary"
                  size="small"
                  style={{ padding: "5px" }}
                  value={right.id}
                  onChange={(e) => onRightsForRoleChange(e)}
                  checked={rightsForRole.includes(right.id)}
                />
                {t(`administration.rolesAndRights.${right.name}`, {
                  defaultValue: right.name,
                })}
              </div>
            );
          }

          subGroupsList.push(
            <fieldset style={{ marginBottom: "20px" }}>
              <legend>
                {t(`administration.rolesAndRights.groups.${subGroup.name}`, {
                  defaultValue: subGroup.name,
                })}
              </legend>
              {rightsList1}
            </fieldset>
          );
        }
      }

      let rightsList2 = [];
      if (dataUI[i].rights) {
        for (let j = 0; j < dataUI[i].rights.length; j++) {
          const right = dataUI[i].rights[j];
          rightsList2.push(
            <div className="flex-iac">
              <Checkbox
                color="primary"
                size="small"
                style={{ padding: "5px" }}
                value={right.id}
                onChange={(e) => onRightsForRoleChange(e)}
                checked={rightsForRole.includes(right.id)}
              />
              {t(`administration.rolesAndRights.${right.name}`, {
                defaultValue: right.name,
              })}
            </div>
          );
        }
      }
      groupList.push(
        <fieldset
          style={{
            paddingLeft: "20px",
            paddingRight: "20px",
            marginBottom: "30px",
          }}
        >
          <legend>
            {t(`administration.rolesAndRights.groups.${dataUI[i].name}`, {
              defaultValue: dataUI[i].name,
            })}
          </legend>
          {subGroupsList.length > 0 && subGroupsList}
          {rightsList2.length > 0 && rightsList2}
        </fieldset>
      );
    }

    return <div>{groupList}</div>;
  }

  function ceduCreateEditRole() {
    function createRole() {
      const data = {
        roleName: roleName,
        rightIds: rightsForRole,
      };

      axios
        .post(link + "/api/RolesAndRights", data, {
          headers: {
            "Content-Type": "application/json",
          },
        })
        .then((response) => {
          props.onChange();
        })

        .catch((error) => {
          setFailShow(true);
        });
    }

    function updateRole() {
      const data = {
        roleID: roleId,
        roleName: roleName,
        rightIds: rightsForRole,
      };
      axios
        .put(link + "/api/RolesAndRights", data, {
          headers: {
            "Content-Type": "application/json",
          },
        })
        .then((response) => {
          props.onChange();
        })
        .catch((error) => {
          setFailShow(true);
        });
    }

    function handleValidSubmit() {
      if (data != null) {
        updateRole();
      } else {
        createRole();
      }
    }
    function cancelSubmit() {
      props.onChange();
    }

    return (
      <AvForm
        onValidSubmit={() => {
          handleValidSubmit();
        }}
      >
        {props.error && props.error ? (
          <Alert color="danger">{props.error}</Alert>
        ) : null}

        <div>
          <div style={{ marginTop: "20px" }}>
            <h3 className="">{heading}</h3>

            <div className="form-group" style={{ width: "50%" }}>
              <AvField
                style={{ height: "25px" }}
                name="rolename"
                autoComplete="new-rolename"
                label={t("administration.rolesAndRights.roleName")}
                value={roleName}
                className="form-control"
                type="rolename"
                required
                onChange={(e) => roleNameChange(e.target.value)}
              />
            </div>

            <div style={{ marginTop: "15px" }}>
              <div className="content-group-name">
                {t("administration.rolesAndRights.rights")}
              </div>
              {rightsList()}
            </div>

            {failShow == true && (
              <div
                className="login-fail"
                style={{
                  marginTop: "20px",
                  marginBottom: "20px",
                  fontSize: "100%",
                }}
              >
                {errorMessage}
              </div>
            )}
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                marginTop: "20px",
                marginBottom: "20px",
              }}
            >
              <button
                type="submit"
                className="button"
                style={{ width: "100px" }}
                onClick={() => cancelSubmit()}
              >
                {t("allgemein.abbruch")}
              </button>
              <button
                type="submit"
                className="button"
                style={{ marginLeft: "10px", width: "100px" }}
              >
                {t("allgemein.speichern")}
              </button>
            </div>
          </div>
        </div>
      </AvForm>
    );
  }

  function renderOption() {
    if (selectedType == "rolesAndRights") {
      return ceduCreateEditRole();
    }
  }

  return <div id="">{renderOption()}</div>;
};

export default CreateEditRole;
